<template>
	<div class="container">
		<div class="resourceDetailBox">
			<div class="resourceTitle">{{pageData.title}}</div>
			<div class="resourceDataBox">
				<div class="dataList">{{pageData.num}} {{$t('resource.reading')}}</div>
				<div class="dataList">13 {{$t('resource.down')}}</div>
				<div class="dataList">{{$t('resource.updateTime')}}: {{pageData.update_time}}</div>
			</div>
			<div class="contentBox">
				<div class="contentLeftBox">
					<div class="abstract">
						{{$t('resource.abstract')}}：{{pageData.remark}}　
					</div>
					<div class="contentDetail">
						<iframe :src="pageData.content_url" frameborder="0" v-if="pageData.suffix == '.pdf'" width="100%" height="100%"></iframe>
						<iframe v-else :src="'https://view.officeapps.live.com/op/view.aspx?src=' + pageData.content_url"  
						width="100%" height="100%" frameborder="0"></iframe>
					</div>
				</div>
				<div class="contentRightBox">
					<div class="newsListBox">
						<div class="newsList" v-for="item,index in dataList" :key="index">
							<div class="ranking" :class="index < 3 ? 'topThree':''">{{index+1}}</div>
							<div class="newsContentBox" @click="toNews(item.id)">
								<div class="newsTitleText">{{item.title}}</div>
								<div class="newsDescText">{{item.update_time}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { formatTimeNum } from '@/utils'
	import { localStorage } from '@/utils/storage.js'
	import * as resource from '@/api/resource'
	
	export default {
	  name: 'ResourceLibraryDetail',
	  data() {
		return {
			id: '',
			pageData: '',
			formData: {
				keywords: '',
				resource_type: '',
				suffix: '',
				dateTime: '',
				begin: '',
				end: '',
				page: 1,
				size: 10,
			},
			dataList: [],
		};
	  },
	  mounted() {
		const id = this.$route.query.id
		;
		this.id = id
		this.getReadData();
		this.getPageList();
	  },
	  methods:{
		// 根据id获取资源
		getReadData(){
			let para = {
				id: this.id
			}
			const lang = localStorage.get('language')
			resource.read(para).then(response => {
			 if(response.code == 0){
				 let data = response.data
				 if(lang == 'en'){
				 	data.update_time = formatTimeNum(data.update_time,'Y-M-D')
				 }else{
				 	data.update_time = formatTimeNum(data.update_time,'Y年M月D日')
				 }
				 this.pageData = data
			 }
			}).catch((res) => {
			  ;
			})
		},
		// 获取列表
		getPageList(){
			let para = this.formData
			const lang = localStorage.get('language')
			resource.index(para).then(response => {
			 if(response.code == 0){
				 let data = response.data.data
				 for (let item of data) {
				 	if(lang == 'en'){
				 		item.update_time = formatTimeNum(item.update_time,'Y-M-D')
				 	}else{
				 		item.update_time = formatTimeNum(item.update_time,'Y年M月D日')
				 	}
				 }
				 this.dataList = data
			 }
			}).catch((res) => {
			  ;
			})
		},
		toNews(id){
			this.$router.push({ path: "/resourceCenterDetail", query: { id: id } })
			this.$router.go(0)
		}
	  }
	  
	}
</script>
<style>
	.contentDetail p{
		margin: 0;
	}
</style>
<style scoped>
	.resourceDetailBox{
		max-width: 1100px;
		width: 90%;
		margin: 0 auto;
		padding: 40px 0;
	}
	.resourceTitle{
		font-size: 30px;
		font-weight: bold;
		color: #333333;
		text-align: center;
		padding: 20px 0;
	}
	.resourceDataBox{
		width: 100%;
		box-sizing: border-box;
		background: #f9f9f9;
		padding: 10px 10px;
		font-size: 15px;
		color: #333333;
		display: flex;
		align-items: center;
	}
	.dataList{
		padding: 0 10px;
		border-right: 1px solid #9a9898;
	}
	.dataList:last-child{
		border: 0;
	}
	.contentBox{
		width: 100%;
		display: flex;
		justify-content: center;
		padding:30px 0;
	}
	.contentLeftBox{
		width: 800px;
		box-sizing: border-box;
		padding-right: 20px;
	}
	.abstract{
		width: 100%;
		padding: 0 0 20px;
		font-size: 15px;
		color: #333333;
		line-height: 1.6;
	}
	.contentDetail{
		color: #333333;
		font-size: 15px;
		width: 100%;
		height: calc(100vh);
	}
	.contentRightBox{
		width: 300px;
	}
	.newsListBox{
		width: 100%;
	}
	.newsList{
		width: 100%;
		display: flex;
		margin-bottom: 20px;
	}
	.ranking{
		width: 24px;
		height: 24px;
		line-height: 24px;
		font-size: 13px;
		color: #ffffff;
		background: #bfbfbf;
		border-radius: 4px;
		margin-right: 10px;
		text-align: center;
	}
	.topThree{
		background: #32589f;
	}
	.newsContentBox{
		width: calc(100% - 34px);
		cursor: pointer;
	}
	.newsTitleText{
		color: #333333;
		font-size: 15px;
		line-height: 24px;
		font-weight: 700;
		margin-bottom: 10px;
		display: -webkit-box;
		overflow: hidden;
		/*! autoprefixer: off; */     
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
	}
	.newsDescText{
		color: #787b8a;
		font-size: 13px;
	}
	
	
	
	
	/* 响应式样式 */
	@media only screen and (max-width: 768px) {
	  .resourceTitle{
		font-size: 24px;
		padding-top: 0;
	  }
	  .resourceDataBox{
		  font-size: 14px;
	  }
	  .resourceDetailBox{
		padding: 20px 0;
	  }
	  .contentBox{
		  flex-wrap: wrap;
		  padding-bottom: 0;
	  }
	  .contentLeftBox{
		  width: 100%;
		  padding: 0;
		  margin-bottom: 40px;
	  }
	  .contentRightBox{
		  width: 100%;
	  }
	}
	@media screen and (min-width: 768px) and (max-width: 999px) { 
		
	}
	@media screen and (min-width: 992px) {  }
	
	@media screen and (min-width: 1200px) {  }
	
	@media screen and (min-width: 1400px) {  }
	
	@media screen and (min-width: 1920px) {  }
</style>